<div class="user-tags" [style.max-width]="maxWidth()">
	@for (tag of visibleUserTags(); track $index) {
		<md-tag
			class="tag-pointer"
			[class.tag-system]="tag.isSystem"
			[type]="tag.tagColor ?? 'tertiary'"
			(click)="openUserTagsDialog(tag)"
			[md-tooltip]="tag.notes"
			md-tooltip-position="bottom"
		>
			<span class="tag-type">{{ tag.tagTypeName }}</span>
			@if (tag.returnDate) {
				<span class="tag-return-date"> | {{ tag.returnDate | date: 'M/d/yyyy' : 'UTC' }}</span>
			}
		</md-tag>
	}
	@if (remainingUserTagsCount() > 0) {
		<md-tag [md-tooltip]="userTagTooltip()" md-tooltip-position="bottom" type="tertiary" size="sm" class="more-tags-indicator">
			+{{ remainingUserTagsCount() }} more
		</md-tag>
	}

	@if (showAddTagButton()) {
		<button md-button (click)="openUserTagsDialog()">Add Tag</button>
	}
</div>
